import {useDispatch, useSelector} from 'react-redux';
import {
  setSelectedPaymentType,
  handleCurrentStep,
  selectSelectedBanData,
  selectPaymentAmount,
  selectBitReturnEvent,
  selectSelectedPaymentType,
  selectCurrentStep,
} from '../DebtAndUpdatePaymentBlockSlice';

export const useDebtPaymentSelectPaymentOption = () => {
  const dispatch = useDispatch();

  const selectedBanData = useSelector(selectSelectedBanData);
  const paymentAmount = useSelector(selectPaymentAmount);
  const bitReturnEvent = useSelector(selectBitReturnEvent);
  const selectedPaymentType = useSelector(selectSelectedPaymentType);
  const bitIsReady = useSelector((state) => state.bitPayment.isReady);
  const currentStep = useSelector(selectCurrentStep);
  const actions = {
    setPaymentType: (value) => dispatch(setSelectedPaymentType(value)),
    goToStep: (step) => dispatch(handleCurrentStep(step)),
  };

  return {
    currentStep,
    selectedBanData,
    paymentAmount,
    bitReturnEvent,
    selectedPaymentType,
    bitIsReady,
    actions,
  };
};
